var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    { staticClass: "settings-page" },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "Permissions" } },
        [_c("permissions-manager")],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        { attrs: { label: "Feature Flags" } },
        [_c("feature-flags-manager")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }